import { breakpoints } from '@bnnvara/breakpoints';
import { pixelToRem } from '@bnnvara/helpers';
import styled from 'styled-components';
import { space } from 'styled-system';
const TextStyle = styled.div`
  color: ${props => props.color};
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
  text-align: ${props => props.center ? 'center' : null};
  font-size: ${pixelToRem(16)};
  line-height: ${pixelToRem(24)};
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${breakpoints.md} {
    font-size: ${pixelToRem(18)};
    line-height: ${pixelToRem(28)};
  }

  ${breakpoints.lg} {
    font-size: ${pixelToRem(20)};
    line-height: ${pixelToRem(32)};
  }

  blockquote {
    font-size: ${pixelToRem(18)};
    line-height: ${pixelToRem(20)};
    line-height: 1.6;
    border-left: 3px solid ${({
  theme
}) => theme.primary.main};
    padding-left: 15px;

    ${breakpoints.md} {
      font-size: ${pixelToRem(20)};
      line-height: ${pixelToRem(24)};
    }

    ${breakpoints.lg} {
      font-size: ${pixelToRem(24)};
      line-height: ${pixelToRem(28)};
    }
  }

  a {
    color: ${({
  theme
}) => theme.primary.main};
    text-decoration: underline;

    &:hover {
      color: ${({
  theme
}) => theme.primary.light};
    }
  }

  ol {
    margin-left: 16px;

    li {
      padding-left: 24px;
      width: 100%;
    }
  }

  ul {
    list-style: none;

    li {
      padding-left: 24px;
      &:before {
        content: '';
        width: 16px;
        height: 4px;
        background-color: ${props => props.color};
        padding-right: 5px;
        display: inline-block;
        position: relative;
        top: -5px;
        left: -24px;
      }
    }
  }
  ${space};
`;
export default TextStyle;